import type { ReactNode } from "react";

export const SettingsFormSection = ({
  title,
  eyebrow,
  children,
}: {
  title: string;
  eyebrow?: string;
  children: ReactNode;
}) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
    <header className="mb-4">
      {eyebrow && (
        <div className="text-xs font-semibold uppercase text-slate-500">
          {eyebrow}
        </div>
      )}
      <h3 className="mt-1 text-base font-semibold text-slate-950">{title}</h3>
    </header>
    {children}
  </section>
);
